import "./tab1.scss";
import DotIndicator from "../../../../../ui/dotindicator/dotindicator";
import RadioButtons from "../../../../../ui/radiobutton/radiobutton";
import HorizontalDivider from "../../../../../ui/horizontaldivider/horizontaldivider";
import * as React from "react";
import {useState} from "react";
import GoalType, {IGoalType} from "../../../../../ui/goaltype/goaltype";
import AutoComplete from "../../../../../ui/autocomplete/autocomplete";
import {autoCompleteItem} from "../../../../../modals/types/autocomplete";
import {RadioButton} from "../../../../../modals/types/radiobutton";
import {DropDownItem} from "../../../../../modals/types/dropdown";
import DropDown from "../../../../../ui/dropdown/dropdown";

const Tab1 = () => {
    const [activate, setActivate] = useState("goal0");
    const [value, setValue] = React.useState('A');
    const [gender, setGender] = React.useState('F');
    const [copied, setCopied] = React.useState(false);
    const goalItems: IGoalType[] = [
        {
            title: "موضوع وبسایت",
            body: "نمایش تبلیغات شما تنها در صفحاتی که موضوع کلی آن صفخات مطابق با موضوعات انتخابی شماست",
            id: 0,
            activate: activate,
            setActivate: setActivate
        },
        {
            title: "هشتگ (تگ ها)",
            body: "نمایش تبلیغات شما تنها در صفحاتی که کلید واژه های انتخابی تان در عنوان یا متا تگ آن ها قرار دارد",
            id: 1,
            activate: activate,
            setActivate: setActivate
        },
        {
            title: "علایق مخاطبان",
            body: "نمایش تبلیغات شما تنها به کاربرانی که رفتار اخیر آن ها در بازدید از صفحات وب مطابق الگوی انتخابی شماست",
            id: 2,
            activate: activate,
            setActivate: setActivate
        },
    ]
    const categoryAutoCompleteItems: autoCompleteItem[] = [
        {title: "سلامت"}, {title: "اقتصاد"}
    ];
    const searchAutoCompleteItems: autoCompleteItem[] = [
        {title: "سلامت"}, {title: "اقتصاد"}
    ];
    const keyWordsAutoCompleteItems: autoCompleteItem[] = [
        {title: "سلامت"}, {title: "اقتصاد"}
    ];
    const dailyRetargetAutoCompleteItems: DropDownItem[] = [
        {label: "1"}, {label: "2"}
    ];
    const delayRetargetAutoCompleteItems: DropDownItem[] = [
        {label: "1"}, {label: "2"}
    ];
    const afterDelayRetargetAutoCompleteItems: DropDownItem[] = [
        {label: "1"}, {label: "2"}
    ];
    const radioContent: RadioButton[] = [
        {label: "هدفمند", currentValue: "A"},
        {label: "ریتارگتینگ", currentValue: "B"}
    ]
    const genderRadioContent: RadioButton[] = [
        {label: "خانم", currentValue: "F"},
        {label: "آقا", currentValue: "M"},
        {label: "هردو", currentValue: "B"}
    ]
    const goalContent: JSX.Element[] = [
        <>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">جستجوی موضوع</label>
                <AutoComplete items={searchAutoCompleteItems} title={"مثال:ساعت"}/>
            </div>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">دسته بندی ها</label>
                <AutoComplete items={categoryAutoCompleteItems} title={"مثال:ساعت"}/>
            </div>
        </>,
        <>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <label className={"mb-2"} htmlFor="">کلید واژه ها</label>
                <AutoComplete items={keyWordsAutoCompleteItems} title={"مثال:بورس"}/>
            </div>
        </>,
        <>
            <div className="col-lg-6 col-md-6 col-12 mb-3">
                <div className="mb-3">
                    <h6 className="mb-3 pt-3">جنسیت</h6>
                    <RadioButtons items={genderRadioContent} value={gender} setValue={setGender}/>
                </div>
                <label className={"mb-2"} htmlFor="">جست و جوی دسته بندی</label>
                <AutoComplete items={categoryAutoCompleteItems} title={"مثال:سلامت"}/>
            </div>
        </>
    ]
    const setRadioContent = (value: string): JSX.Element => {
        if (value === "A") {
            return (
                <>
                    <div className="row pt-3">
                        <div className="d-flex align-items-center mb-4">
                            <DotIndicator/>
                            <span>نوع هدفمندی</span>
                        </div>
                        {
                            goalItems.map((goalItem, index) => {
                                return (
                                    <div key={index} className="col-lg-4 col-md-6 col-12 mb-3">
                                        <GoalType activate={goalItem.activate} title={goalItem.title}
                                                  body={goalItem.body}
                                                  setActivate={goalItem.setActivate} id={goalItem.id}/>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="row pt-4">
                        {goalContent[parseInt(activate.substring(4, 5))]}
                    </div>
                </>
            );
        } else if (value === "B") {
            return (
                <>
                    <div className="row">
                        <label className="py-3" htmlFor="script">برای اجرای کمپین ریتارگتینگ باید اسکریپت ما را در تگ
                            head وبسایت خود قراردهید
                            و لینک یا دکمه برای کپی کردن اسکریپت وجود داشته باشد
                        </label>
                        <div className="col-lg-7 col-12">
                            <div className="d-flex flex-row justify-content-start align-items-center mb-3">
                                <button onClick={async () => {
                                    try {
                                        await navigator.clipboard.writeText("https://www.figma.com/file/yHyIxKvm7lClsG1vfrUkrm");
                                        setCopied(true);
                                        setTimeout(() => {
                                            setCopied(false);
                                        }, 3000)
                                    } catch (err) {
                                        console.log(err)
                                    }
                                }} className="Copy-Button">{copied ? "کپی شد" : "کپی کنید"}</button>
                                <input type="text" value=""
                                       placeholder="https://www.figma.com/file/yHyIxKvm7lClsG1vfrUkrm"
                                       name="script" id="script" className="Campaign-Input Tab1-Input"/>
                            </div>
                        </div>
                    </div>
                    <HorizontalDivider/>
                    <div className="row pt-3">
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label className={"mb-2"} htmlFor="">مخاطبان شما حداکثر روزی چند بار ریتارگت شوند؟</label>
                            <DropDown items={dailyRetargetAutoCompleteItems} placeHolder={"انتخاب کنید"}/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label className={"mb-2"} htmlFor="">مخاطبان شما با چند روز تاخیر ریتارگت شوند؟</label>
                            <DropDown items={delayRetargetAutoCompleteItems} placeHolder={"انتخاب کنید"}/>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mb-3">
                            <label className={"mb-2"} htmlFor="">مخاطبان شما تا چند روز بعد از تاخیر ریتارگت
                                شوند؟</label>
                            <DropDown items={afterDelayRetargetAutoCompleteItems} placeHolder={"انتخاب کنید"}/>
                        </div>
                    </div>
                </>
            );
        } else {
            return <></>
        }
    }

    return (
        <div className="Tab1">
            <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div className="d-flex align-items-center mb-4">
                        <DotIndicator/>
                        <span>نوع کمپین</span>
                    </div>
                </div>
                <div className="col-lg-9 col-md-9 col-sm-9 col-12">
                    <RadioButtons items={radioContent} value={value} setValue={setValue}/>
                </div>
            </div>
            <HorizontalDivider/>
            <div className="">
                {setRadioContent(value)}
            </div>
        </div>
    );
}

export default Tab1;